<template>
  <div>
    <b-table :data="documents">
      <template slot-scope="props">
        <b-table-column width="450" label="Name">
            {{props.row['purchase_order__DOCUMENT__purchaseOrderID::zctFileNameContainer'] }}
        </b-table-column>
        <!--<b-table-column label="Description">-->
        <!--  <b-input v-model="props.row['purchase_order__DOCUMENT__purchaseOrderID::description']">-->
            <!--{{props.row['purchase_order__DOCUMENT__purchaseOrderID::description'] }}-->
        <!--  </b-input>-->
        <!--</b-table-column>-->
        <b-table-column label="Creator">
            {{props.row['purchase_order__DOCUMENT__purchaseOrderID::creationName'] }}
        </b-table-column>
        <b-table-column label="Date">
            {{props.row['purchase_order__DOCUMENT__purchaseOrderID::documentDate'] }}
        </b-table-column>
        <b-table-column label="Size">
            {{props.row['purchase_order__DOCUMENT__purchaseOrderID::size'] }}
        </b-table-column>
        <b-table-column label=" ">
          <button v-if="props.row['purchase_order__DOCUMENT__purchaseOrderID::fileExt'] != 'pdf'" class="button is-primary is-outlined is-small no-print" @click="props.row.showDoc = true">View</button>
          <b-modal has-modal-card :active.sync="props.row.showDoc" :width="960">
            <document-card :row="props.row"></document-card>
          </b-modal>
          <a target="_blank" :href="props.row['purchase_order__DOCUMENT__purchaseOrderID::document']" download>Download</a>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DocumentViewCard from './DocumentViewCard'

export default {
  name: 'PurchaseOrderDocuments',
  props: ['documents'],
  components:{
    'document-card': DocumentViewCard,
  },
  data(){
    return{
      // isComponentModalActive: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>




// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderDocuments.vue